import { api } from '@/lib/axios'
import type { CalcGroup, CalcPosition, CalcRaster, CalcTrashEntry, CalcUnit } from '../types/calculation.types'

/** AP-37 8. — Positionen und Gruppen (`/calculations/:id/positions`, `/groups`). */
const basis = (id: string) => `/calculations/${id}`

export const fetchRaster = (id: string) => api.get<{ data: CalcRaster }>(`${basis(id)}/positions`).then((r) => r.data.data)

export const createPosition = (id: string, dto: { shortText: string; quantity?: number; unitId?: string; groupId?: string; afterId?: string }) =>
  api.post<{ data: CalcPosition }>(`${basis(id)}/positions`, dto).then((r) => r.data.data)

export const deletePositions = (id: string, ids: string[]) =>
  api.post<{ data: CalcRaster }>(`${basis(id)}/positions/delete`, { ids }).then((r) => r.data.data)

export const fetchPositionTrash = (id: string) =>
  api.get<{ data: CalcTrashEntry[] }>(`${basis(id)}/positions/trash`).then((r) => r.data.data)

export const restorePositions = (id: string, ids: string[]) =>
  api.post<{ data: CalcRaster }>(`${basis(id)}/positions/restore`, { ids }).then((r) => r.data.data)

export const reorderPositions = (id: string, dto: { ids: string[]; moved?: string[]; groupId?: string | null }) =>
  api.post<{ data: CalcRaster }>(`${basis(id)}/positions/reorder`, dto).then((r) => r.data.data)

export const copyPositions = (id: string, dto: { ids?: string[]; groupIds?: string[] }) =>
  api.post<{ data: unknown[]; copied: number }>(`${basis(id)}/positions/copy`, dto).then((r) => r.data)

export const pastePositions = (id: string, dto: { groupId?: string }) =>
  api.post<{ data: CalcRaster; pasted: number; skipped: number }>(`${basis(id)}/positions/paste`, dto).then((r) => r.data)

export const createGroup = (id: string, dto: { name: string; parentId?: string }) =>
  api.post<{ data: CalcGroup }>(`${basis(id)}/groups`, dto).then((r) => r.data.data)

export const deleteGroup = (id: string, gid: string) => api.delete<{ data: CalcRaster }>(`${basis(id)}/groups/${gid}`).then((r) => r.data.data)

export const fetchUnits = () => api.get<{ data: CalcUnit[] }>('/calculations/lookups/units').then((r) => r.data.data)

export const fetchClipboardCount = () => api.get<{ data: unknown[] }>('/clipboard').then((r) => r.data.data.length)
